import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=4165b1c0&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4165b1c0",
  null
  
)

export default component.exports